import React from 'react';

import PropTypes from 'prop-types';

import { AriaDescription } from 'components/AriaDescription';
import { StyledPageHeading } from 'components/PortalPage/styles';
import { useTranslations } from 'utils/hooks/useTranslations';

import { AdditionalNavigation, NavBar, MainNavigation, Wrapper } from './styles';

const subNavigationAriaLabelId = 'sub-navigation-aria-label';

const NavigationBar = ({ mainNavigation, additionalNavigation }) => {
  const t = useTranslations('pages.inquiryDetails');
  return (
    <header>
      <StyledPageHeading as="h1">{t('heading')}</StyledPageHeading>
      <AriaDescription id={subNavigationAriaLabelId}>{t('subNavigationAriaLabel')}</AriaDescription>
      <NavBar aria-labelledby={subNavigationAriaLabelId}>
        <Wrapper>
          {mainNavigation && <MainNavigation>{mainNavigation}</MainNavigation>}
          {additionalNavigation && (
            <AdditionalNavigation>{additionalNavigation}</AdditionalNavigation>
          )}
        </Wrapper>
      </NavBar>
    </header>
  );
};

NavigationBar.propTypes = {
  mainNavigation: PropTypes.node,
  additionalNavigation: PropTypes.node,
};

NavigationBar.defaultProps = {
  mainNavigation: null,
  additionalNavigation: null,
};
export default NavigationBar;
